import * as React from 'react';

export const StylaLogo = ( props ) => {
    const color = props.color || '#000';

    return(
        <svg
            /* tslint:disable */
            version="1.1"id="Layer_1" xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            width="25px" height="25px" viewBox="0 0 25 25"
            xmlSpace="preserve"
            /* tslint:enable */

            style={ {
                fill : color,
            } }
        >

        { /* tslint:disable */ }
        <path d="M14.041,8.122H1.885C1.201,8.071,0.69,7.479,0.742,6.799c0.044-0.614,0.529-1.099,1.143-1.143h12.156
            c0.68,0.052,1.19,0.643,1.14,1.323C15.136,7.589,14.651,8.078,14.041,8.122"/>
        <path d="M19.017,13.733H5.004c-0.68,0.052-1.275-0.459-1.327-1.139c-0.047-0.684,0.463-1.275,1.143-1.327
            c0.062-0.004,0.121-0.004,0.184,0h14.012c0.684-0.048,1.279,0.463,1.323,1.143c0.052,0.68-0.456,1.272-1.14,1.323
            C19.142,13.737,19.075,13.737,19.017,13.733"/>
        <path d="M23.11,19.349H10.954c-0.68,0.052-1.275-0.463-1.323-1.139c-0.052-0.684,0.459-1.279,1.139-1.323
            c0.062-0.015,0.121-0.015,0.184,0H23.11c0.684-0.059,1.271,0.456,1.331,1.132c0.044,0.684-0.471,1.279-1.147,1.33
            C23.235,19.356,23.177,19.356,23.11,19.349"/>
        <path d="M17.694,24.957H3.678c-0.68,0.059-1.271-0.456-1.323-1.14s0.463-1.271,1.143-1.322c0.059-0.008,0.121-0.008,0.18,0h14.017
            c0.683,0.051,1.19,0.639,1.146,1.322C18.796,24.428,18.304,24.913,17.694,24.957"/>
        <path d="M21.707,2.511H7.691C7.011,2.459,6.5,1.864,6.552,1.184c0.044-0.61,0.529-1.095,1.139-1.139h14.016
            c0.676-0.051,1.278,0.459,1.322,1.139c0.052,0.68-0.455,1.275-1.139,1.327C21.824,2.515,21.766,2.515,21.707,2.511"/>
        { /* tslint:enable */ }
        </svg>
    );
};



// WEBPACK FOOTER //
// ./src/StylaLogo.js